module.exports = __webpack_public_path__ + "static/media/orders.567f77ce.png";